import RentedPlacesTable from '@/pages/tenant/RentedProperties/RentedPlacesTable';
import React from 'react';
import Card from '@/components/shared/Card';
import './RentedPropertiesPage.scss';

const baseClass = 'RentedPropertiesPage';

const RentedPropertiesPage = () => {
  return (
    <div className={baseClass}>
      <Card className={`${baseClass}__units mb-24`}>
        <Card.Header className={`${baseClass}__units-header`}>
          <Card.Title className={`${baseClass}__units-header-title`}>
            <span className={`${baseClass}__units-header-title-text`}>
              Rented places
            </span>
          </Card.Title>
          <Card.TitleDescription
            className={`${baseClass}__units-header-title-description`}
          >
            All properties you are currently renting.
          </Card.TitleDescription>
        </Card.Header>
        <Card.Body className={`${baseClass}__units-body`}>
          <RentedPlacesTable />
        </Card.Body>
      </Card>
    </div>
  );
};

export default RentedPropertiesPage;
